import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'

import HeroSection from '@/components/landing/hero-section'
import IntroSection from '@/components/landing/intro-section'
import MarqueeBand from '@/components/landing/marquee-band'
import WhoWeAreSection from '@/components/landing/who-we-are-section'
import ServicesSection from '@/components/landing/services-section'
import AudiencesSection from '@/components/landing/audiences-section'
import ProcessSection from '@/components/landing/process-section'
import TeamSection from '@/components/landing/team-section'
import ContactSection from '@/components/landing/contact-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <IntroSection />
            <MarqueeBand />
            <WhoWeAreSection />
            <ServicesSection />
            <AudiencesSection />
            <ProcessSection />
            <TeamSection />
            <ContactSection />
        </Layout>
    )
}

export default Home
